import { Action, createReducer, on } from '@ngrx/store';
import { showDarkTheme } from './actions/login-menu.actions';
import { setWideMode } from './actions/login-menu.actions';

export interface AuthState {
    themeDark: string;
    wideMode: string;
}

export const initialState: AuthState = {
    themeDark: null,
    wideMode: null
};

export const authFeatureKey = 'auth';

const authReducer = createReducer(
    initialState,
    on(showDarkTheme, state => ({
        ...state,
        themeDark: !!state.themeDark ? null : 'theme--dark'
    })),
    on(setWideMode, state => ({
        ...state,
        wideMode: !!state.wideMode ? null : 'width--wide'
    }))
);

export function reducer(state: AuthState | undefined, action: Action) {
    return authReducer(state, action);
}
